import { render } from "./templa.vue?vue&type=template&id=c70f3ad8&scoped=true"
import script from "./templa.vue?vue&type=script&lang=js"
export * from "./templa.vue?vue&type=script&lang=js"

import "./templa.vue?vue&type=style&index=0&id=c70f3ad8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c70f3ad8"]])

export default __exports__